import { BaseUseCase } from "../../../../useCases/UseCaseBase";
class CalculateMarginUseCase extends BaseUseCase {
    constructor(marginRepo) {
        super();
        this.marginRepo = marginRepo;
    }
    async fetchResult(req) {
        return await this.marginRepo.calculateMargin(req);
    }
}
export default CalculateMarginUseCase;
